<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- 1. الفلتر والتحكم -->
    <div class="card shadow-sm mb-4 no-print border-0">
      <div class="card-body">
        <!-- استخدام flex-column للموبايل و flex-md-row للشاشات الأكبر -->
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
          
          <h4 class="text-primary fw-bold mb-0 text-center text-md-start">
            <i class="fas fa-chart-pie ms-2"></i> الإحصائيات العامة للامتحانات
          </h4>
          
          <div class="d-flex flex-column flex-sm-row gap-2 align-items-center w-100 w-md-auto">
            <div class="input-group w-100 w-sm-auto">
              <span class="input-group-text bg-light fw-bold">المادة</span>
              <select v-model="selectedSubject" @change="fetchStats" class="form-select">
                <option value="">-- عرض المقيدين فقط --</option>
                <option v-for="sub in subjects" :key="sub.id" :value="sub.id">{{ sub.name }}</option>
              </select>
            </div>
            
            <button @click="printPage" class="btn btn-dark w-100 w-sm-auto">
              <i class="fas fa-print ms-1"></i> طباعة
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- حاوية الطباعة (تشمل الملخص والجداول) -->
    <div id="printMe">

      <!-- ترويسة الطباعة فقط -->
      <div class="d-none d-print-block text-center mb-4 pt-3">
         <h2 class="fw-bold">تقرير الإحصائيات العامة</h2>
         <p>لجنة النظام والمراقبة - الشهادة الإعدادية</p>
         <hr>
      </div>

      <!-- 2. كروت الملخص (Dashboard) -->
      <div v-if="summary" class="row g-3 mb-4 text-center">
        <!-- إجمالي الطلاب -->
        <div class="col-6 col-lg-3">
          <div class="card bg-primary text-white shadow-sm h-100 border-0">
            <div class="card-body p-3">
              <i class="fas fa-users fa-2x mb-2 opacity-50"></i>
              <h3 class="fw-bold mb-1">{{ summary.total_students }}</h3>
              <p class="mb-0 small opacity-75">إجمالي المقيدين</p>
            </div>
          </div>
        </div>
        
        <!-- الحضور -->
        <div class="col-6 col-lg-3">
          <div class="card bg-success text-white shadow-sm h-100 border-0">
            <div class="card-body p-3">
              <i class="fas fa-user-check fa-2x mb-2 opacity-50"></i>
              <h3 class="fw-bold mb-1">{{ summary.total_present }}</h3>
              <p class="mb-0 small opacity-75">عدد الحضور</p>
            </div>
          </div>
        </div>

        <!-- الغياب -->
        <div class="col-6 col-lg-3">
          <div class="card bg-danger text-white shadow-sm h-100 border-0">
            <div class="card-body p-3">
              <i class="fas fa-user-times fa-2x mb-2 opacity-50"></i>
              <h3 class="fw-bold mb-1">{{ summary.total_absent }}</h3>
              <p class="mb-0 small opacity-75">عدد الغياب</p>
            </div>
          </div>
        </div>

        <!-- نسبة الحضور -->
        <div class="col-6 col-lg-3">
          <div class="card bg-dark text-white shadow-sm h-100 border-0">
            <div class="card-body p-3">
              <i class="fas fa-percent fa-2x mb-2 opacity-50"></i>
              <h3 class="fw-bold mb-1">{{ summary.attendance_rate }}%</h3>
              <p class="mb-0 small opacity-75">نسبة الحضور</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 3. الجداول التفصيلية -->
      <div class="card shadow-sm border-0">
        <div class="card-header bg-white p-0 no-print border-bottom">
          <ul class="nav nav-tabs card-header-tabs m-0 border-0">
            <li class="nav-item flex-fill text-center">
              <a class="nav-link fw-bold py-3 rounded-0 border-0 border-bottom-active" :class="{ active: activeTab === 'committees' }" @click.prevent="activeTab = 'committees'" href="#">
                <i class="fas fa-building ms-1"></i> <span class="d-none d-sm-inline">إحصاء</span> اللجان ({{ summary?.total_committees }})
              </a>
            </li>
            <li class="nav-item flex-fill text-center">
              <a class="nav-link fw-bold py-3 rounded-0 border-0 border-bottom-active" :class="{ active: activeTab === 'schools' }" @click.prevent="activeTab = 'schools'" href="#">
                <i class="fas fa-school ms-1"></i> <span class="d-none d-sm-inline">إحصاء</span> المدارس ({{ summary?.total_schools }})
              </a>
            </li>
          </ul>
        </div>

        <div class="card-body p-0">
          
          <!-- عنوان فرعي للطباعة -->
          <div class="d-none d-print-block text-center py-2 bg-light border-bottom">
            <h5 class="m-0 fw-bold">
              توزيع {{ activeTab === 'committees' ? 'اللجان' : 'المدارس' }}
              <span v-if="selectedSubjectName"> - مادة: {{ selectedSubjectName }}</span>
            </h5>
          </div>

          <!-- جدول اللجان -->
          <div v-if="activeTab === 'committees'" class="table-responsive">
            <table class="table table-bordered table-striped table-hover text-center align-middle mb-0 text-nowrap">
              <thead class="table-dark">
                <tr>
                  <th style="width: 5%">م</th>
                  <th style="width: 35%">اسم اللجنة / المقر</th>
                  <th>المقيدين</th>
                  <th>حضور</th>
                  <th>غياب</th>
                  <th style="width: 20%">النسبة</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in committees" :key="item.id">
                  <td>{{ index + 1 }}</td>
                  <td class="text-start fw-bold text-wrap" style="min-width: 200px;">{{ item.commitee_name }}</td>
                  <td>{{ item.students_count }}</td>
                  <td class="text-success fw-bold">{{ item.students_count - item.absents_count }}</td>
                  <td class="text-danger fw-bold">{{ item.absents_count }}</td>
                  <td>
                    <div class="d-flex align-items-center">
                      <div class="progress flex-grow-1" style="height: 15px;">
                        <div 
                          class="progress-bar bg-success" 
                          role="progressbar" 
                          :style="{ width: calculateRate(item.students_count, item.absents_count) + '%' }"
                        ></div>
                      </div>
                      <small class="ms-2 fw-bold">{{ calculateRate(item.students_count, item.absents_count) }}%</small>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- جدول المدارس -->
          <div v-if="activeTab === 'schools'" class="table-responsive">
            <table class="table table-bordered table-striped table-hover text-center align-middle mb-0 text-nowrap">
              <thead class="table-dark">
                <tr>
                  <th style="width: 5%">م</th>
                  <th style="width: 35%">اسم المدرسة</th>
                  <th>المقيدين</th>
                  <th>حضور</th>
                  <th>غياب</th>
                  <th style="width: 20%">النسبة</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in schools" :key="item.id">
                  <td>{{ index + 1 }}</td>
                  <td class="text-start fw-bold text-wrap" style="min-width: 200px;">{{ item.school_name }}</td>
                  <td>{{ item.students_count }}</td>
                  <td class="text-success fw-bold">{{ item.students_count - item.absents_count }}</td>
                  <td class="text-danger fw-bold">{{ item.absents_count }}</td>
                  <td>
                    <div class="d-flex align-items-center">
                      <div class="progress flex-grow-1" style="height: 15px;">
                        <div 
                          class="progress-bar bg-info" 
                          role="progressbar" 
                          :style="{ width: calculateRate(item.students_count, item.absents_count) + '%' }"
                        ></div>
                      </div>
                      <small class="ms-2 fw-bold">{{ calculateRate(item.students_count, item.absents_count) }}%</small>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>

    </div> <!-- نهاية منطقة الطباعة -->

  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "Statistics",
  data() {
    return {
      loading: false,
      activeTab: 'committees',
      selectedSubject: "",
      
      subjects: [],
      summary: null,
      committees: [],
      schools: [],
      polling: null
    };
  },
  computed: {
    selectedSubjectName() {
      const sub = this.subjects.find(s => s.id === this.selectedSubject);
      return sub ? sub.name : '';
    }
  },
mounted() {
  // 1. الاستدعاء الأول (يظهر اللودينج)
  this.fetchStats(); 

  // 2. تشغيل التحديث التلقائي كل 30 ثانية (بدون لودينج)
  this.polling = setInterval(() => {
    this.fetchStats(true); // نرسل true ليعرف أنها عملية خلفية
  }, 30000);
},

beforeDestroy() {
  // تنظيف الذاكرة وإيقاف العداد عند الخروج من الصفحة
  if (this.polling) {
    clearInterval(this.polling);
  }
},
  methods: {
    async fetchStats(isBackground = false) {
    
    // إذا لم تكن عملية خلفية (يعني أول مرة أو ضغط زر)، أظهر اللودينج
    if (!isBackground) {
      this.loading = true;
    }

    try {
      const res = await api.get('/admin/exam-statistics', {
        params: { subject_id: this.selectedSubject }
      });
      
      // تحديث البيانات بصمت
      this.summary = res.data.summary;
      this.committees = res.data.committees;
      this.schools = res.data.schools;
      this.subjects = res.data.subjects;

    } catch (error) {
      // في التحديث الخلفي، لا تزعج المستخدم برسائل خطأ (alert) إلا للضرورة القصوى
      // أو اكتفِ بطباعتها في الكونسول لعدم مقاطعة عمله
      console.error("خطأ في التحديث التلقائي:", error);
      if (!isBackground) {
         alert("حدث خطأ أثناء جلب الإحصائيات");
      }
    } finally {
      // إخفاء اللودينج في كل الأحوال
      this.loading = false;
    }
  },

    calculateRate(total, absent) {
      if (total === 0) return 0;
      const present = total - absent;
      return Math.round((present / total) * 100);
    },

    printPage() {
      // طباعة القسم المحدد (شاملاً الملخص والجداول)
      this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
/* تحسين التابات */
.nav-tabs .nav-link {
  color: #6c757d;
  background-color: #f8f9fa;
  transition: all 0.3s;
}
.nav-tabs .nav-link.active {
  color: #0d47a1; /* لون الكنترول الأزرق */
  background-color: #fff;
  border-bottom: 3px solid #0d47a1; /* خط سفلي بدلاً من علوي */
}

/* تنسيقات الموبايل */
@media (max-width: 768px) {
  h4 { font-size: 1.2rem; }
  .card-body h3 { font-size: 1.5rem; }
  /* تصغير خطوط الجدول قليلاً في الموبايل */
  .table { font-size: 0.9rem; }
}

/* تنسيقات الطباعة */
@media print {
  body * {
    visibility: hidden;
  }
  
  .no-print {
    display: none !important;
  }

  #printMe, #printMe * {
    visibility: visible;
  }

  #printMe {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  /* إجبار الأعمدة في الملخص على الظهور بجانب بعضها في الطباعة (4 أعمدة) */
  .col-lg-3 {
    width: 25% !important;
    float: right !important; /* لدعم RTL */
    flex: 0 0 25% !important;
  }

  /* تحسين الجدول للطباعة */
  .table {
    width: 100% !important;
    border-collapse: collapse !important;
  }
  
  th, td {
    border: 1px solid #000 !important;
    padding: 8px !important;
    font-size: 12pt !important;
    color: #000 !important;
  }

  /* إظهار الألوان والخلفيات */
  .bg-primary, .bg-success, .bg-danger, .bg-dark, .table-dark, .progress-bar {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  
  .text-white {
      color: white !important;
  }
  
  /* إزالة الظلال والحدود الزائدة */
  .card { border: none !important; shadow: none !important; }
}
</style>